module.exports = __webpack_public_path__ + "img/784ba4f015dba2c9f8070f5cea6f1137.png";